import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteDepartment as apiDeleteDepartment } from "../../api/apiDepartments";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";

/**
 * Hook لحذف قسم
 */
export function useDeleteDepartment() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteDepartment,
        isPending: isDeleting,
        error,
    } = useMutation({
        mutationFn: (id) => apiDeleteDepartment(id),
        onSuccess: (response) => {
            toast.success(response.message || 'Department deleted successfully');
            queryClient.invalidateQueries({
                queryKey: ["departments"],
            });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Failed to delete department");
            toast.error(msg);
        },
    });

    return { deleteDepartment, isDeleting, error };
}
